import { useIdentityStatus } from '@/lib/api/hooks';
import { cn } from '@/lib/cn';

export const CARE_PURCHASE_NOTE =
  'You can purchase before uploading your photo ID. Clinical review starts once your intake and photo ID are complete. Your clinician verifies your identity during prescribing; treatment and prescriptions require clinical approval.';

/** Rollout visibility only: never controls payment, consent, or navigation. */
export function CarePurchaseNote({ inverse = false }: { inverse?: boolean }) {
  const identity = useIdentityStatus();
  if (identity.data?.enabled !== true || identity.isError) return null;
  return (
    <p
      className={cn(
        'mt-10 type-body-sm leading-145',
        inverse ? 'text-ink-onInverse/70' : 'text-ink-secondary',
      )}
    >
      {CARE_PURCHASE_NOTE}
    </p>
  );
}
